// 0、待执行；1-执行中；2-暂停；4-已取消；3-已完成 5-失败
import  {getContents,getchannels} from '@/api/cms.js'

export const channels = {
    'index': '首页',

    'product': '产品及服务',
    'robotList': '建筑机器人',
    'digitization': '数字科技',
    'prefabricated': '新型建筑工业化',
    'construction': '智慧施工',
    'download': '下载中心',

    'contact': '联系我们',

    'newsTitle': '新闻资讯',
    'news': '公司新闻',
    'media': '媒体报道',

    'understand': '走进博智林',
    'introduction': '公司简介',
    'honor': '合作与成果',

    'join': '加入我们',
    'staffLife': '员工生活',
    'recruit': '人才招募',
    'joinBzl': '加入博智林',
    'train': '员工培养',
};

export default {
    install(Vue, options) {
        Vue.prototype.$channels = channels;

        Vue.prototype.$initChannelsIds = async function () {
            if (!window.sessionStorage.getItem("CHANNEL_IDS")) {
                let channelsIds ={};
                let res = await getchannels(process.env.VUE_APP_BZL_SITE_ID);
                console.log("res.data", res.data);

                // 赋值
                res.data.forEach(item => {
                    Object.keys(channels).forEach(key => {
                        if (item.channelName === channels[key]) {
                            channelsIds[channels[key]] = item.id;
                        }
                    })
                });
                sessionStorage.setItem('CHANNEL_IDS',JSON.stringify(channelsIds));
            }

            console.log("sessionStorage.getItem(CHANNEL_IDS)", JSON.parse(window.sessionStorage.getItem("CHANNEL_IDS")));
            return  JSON.parse(window.sessionStorage.getItem("CHANNEL_IDS"));
        };

        Vue.prototype.$getContents = async function (channelName) {
            if (!window.sessionStorage.getItem("CONTENTS_"+channelName)) {
                let channelId ;
                await this.$initChannelsIds().then(res => channelId = res[channelName]);
                console.log("channelId",channelId);
                let res = await getContents({siteId: process.env.VUE_APP_BZL_SITE_ID,channelId:channelId});
                console.log("data.contents", res.data.contents);
                sessionStorage.setItem("CONTENTS_"+channelName,JSON.stringify( res.data.contents));
            }

            console.log("sessionStorage.getItem(CONTENTS_)"+channelName,JSON.parse(window.sessionStorage.getItem("CONTENTS_"+channelName)));
            return  JSON.parse(window.sessionStorage.getItem("CONTENTS_"+channelName));
        };

        Vue.prototype.$wrapDiv= async function (content){
            //内容渲染
            let el =await document.createElement("div");
            el.innerHTML  = content;

            await  document.getElementById("content");
            let maxWidth =await document.getElementById("content").clientWidth;

            console.log("maxWidth",maxWidth)
            console.log("before wrap el",el)

            if (el.getElementsByTagName("img").length > 0) {
                await Array.from(el.getElementsByTagName("img")).forEach(item => {

                    let img = new Image();
                    img.src = item.src;
                    img.onerror = ()=>{ console.log("img.onerror",item.src)};
                    img.onload = () =>{
                        console.log("img.onload",item.src);
                        let ratio;  // 缩放比例
                        let width = item.naturalWidth;
                        let height = item.naturalHeight;

                        console.log("width",width);
                        console.log("height",height);

                        // 检查图片是否超宽
                        // if (width > maxWidth) {
                        //计算缩放比例
                        ratio = maxWidth / width;
                        height = height * ratio;    // 计算等比例缩放后的高度
                        item.style.width = maxWidth+"px";
                        item.style.height  = height+"px";
                        // }
                        console.log("item.style.width",item.style.width);
                        console.log(" item.style.height", item.style.height);
                    };

                    item.style.marginLeft = "0px";
                    item.style.marginRight = "0px";
                });
            }

            if (el.getElementsByTagName("video").length > 0) {
                await Array.from(el.getElementsByTagName("video")).forEach(item => {



                    let videoWidth = item.clientWidth;
                    console.log("videoWidth",videoWidth);
                    if (videoWidth>maxWidth){
                        item.style.width = maxWidth+"px";
                    }



                });
            }

            if (el.childNodes.length > 0) {
                await Array.from(el.childNodes).forEach(item => {
                    // item.style.width = winWidth+"px";
                    //  item.style.height  = winHeight+"px";
                    if (item.style.width > maxWidth) {
                        item.style.width = "auto";
                        item.style.height  = "auto";
                    }
                });
            }
            console.log("after wrap el",el);
            await document.getElementById("content").appendChild(el);
            console.log("getElementById",document.getElementById("content"));
        }

    }
}